module.exports = __webpack_public_path__ + "assets/img/u4.39f88bc5.png";